import { CmDetailsDataStructure } from 'components/DetailsPageBoilerplate/types';

export enum ActionType {
  SET_CLUB = 'SHOW_CLUB/SET_CLUB',
  SET_IS_LOADING = 'SHOW_CLUB/SET_IS_LOADING',
}

export const setClub = (firm: CmDetailsDataStructure) => ({
  type: ActionType.SET_CLUB,
  payload: firm,
});

export const setIsLoading = (isLoading: boolean) => ({
  type: ActionType.SET_IS_LOADING,
  payload: isLoading,
});
